import type { Option, Branch } from './nodes'
export default {
  11: (): Branch => {
    return {
      type: 'BranchOption',
      title: '请问你对本次服装OEM的初步需求是怎样的？',
      key: 'clothingQuestionInitialRequirement',
      options: [
        {
          label:
            '只需要生产出和图片或链接看起来一样的产品，对面料没有任何要求，且不需要有任何设计上的改动。',
          value: 'A',
          tooltip:
            '风险告知：A的情况，此选项不寄实物样品给客户，只通过样衣图片在线上进行确认。此选项优点为出样快，缺点为直行便只保证成衣外观和客户提供的图片接近一致无法保证和原链接衣服材质保持一致。请知悉！',
          next: '8'
        },
        {
          label: '我有样衣，希望直行便帮我生产出和样衣一模一样的衣服。',
          value: 'B',
          next: '3',
          bridge: '112'
        },
        {
          label: '我有样衣，但我对设计/面料/尺寸等，有希望改动的地方。',
          value: 'C',
          next: '3',
          bridge: '2'
        },
        {
          label: '我只有参考图片或链接，且我有需要改动的地方或我对面料有拘泥。',
          value: 'D',
          tooltip:
            '此种情况您需要尽可能提供一件样衣到直行便作为参考，或者您需要提供详细的式样书，如果您没有式样书，可以联系直行便使用式样书制作服务',
          next: '114'
        },
        {
          label:
            '我没有样衣或参考图片/链接，但我有式样书，希望直行便根据式样书帮我进行生产。',
          value: 'E',
          tooltip:
            '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务',
          next: '6',
          bridge: '112'
        }
      ],
      long: true
    }
  },
  111: (prev: any, data: any): Branch => {
    const options = [
      {
        label: '我有尺码对应的尺寸数值。',
        value: 'A',
        tooltip:
          '根据服装生产标准，尺寸相差 1-3cm 都属于正常现象，不作为不良品判断，请知悉',
        next: '1111'
      },
      {
        label: '',
        value: 'B',
        next: '9'
      },
      {
        label: '我没有数值，请直行便提供。',
        value: 'C',
        next: '9'
      }
    ]
    if (
      data.clothingQuestionInitialRequirement === 'B' ||
      data.clothingQuestionInitialRequirement === 'C'
    ) {
      options[1].label = '我没有数值，请参考样衣尺寸。'
    } else {
      options[1].label = '我没有数值，请参考链接尺寸。'
    }
    return {
      type: 'BranchOption',
      title: '请问你能够提供尺码的具体尺寸吗？',
      key: 'clothingQuestionProvideSize',
      options,
      long: true
    }
  },
  1111: (): any => {
    return {
      type: 'InfoForm',
      title: '请提供尺码的具体尺寸',
      items: [
        {
          type: 'download',
          label: '尺码模板',
          text: '模板下载',
          url: 'https://theckbstest-oss.theckbs.com/customer/header/テンプレートファイル.xlsx',
          tooltip: '请先下载对应模板，填写完成后上传'
        },
        {
          type: 'file',
          label: '上传模板',
          key: 'sizeValue',
          filename: ''
        }
      ],
      next: '9'
    }
  },
  112: (prev: any, data: any): Branch => {
    const options: Option[] = [
      {
        label: '知道，我可以提供面料信息和具体的色卡信息',
        value: 'A',
        next: '4',
        bridge: '8'
      },
      {
        label: '不知道，希望直行便帮我找到和样衣或参考图片一样的面料',
        value: 'B',
        next: '8'
      }
    ]
    if (data.clothingQuestionInitialRequirement !== 'B') {
      options.push({
        label: '不知道，希望直行便可以根据我的需求，给我推荐合适的面料',
        value: 'C',
        next: '1121',
        bridge: '8'
      })
    }
    if (data.clothingQuestionInitialRequirement === 'E') {
      options.push({
        label:
          '不知道，但是我可以邮寄面料样布，希望直行便帮我找到和样布一样的面料',
        value: 'D',
        next: '3',
        bridge: '8'
      })
    }
    return {
      type: 'BranchOption',
      title: '请问你是否知道面料具体信息？',
      key: 'clothingQuestionKnowFabricDetail',
      options,
      long: true
    }
  },
  1121: (prev: any): any => {
    const next = prev.bridge
    return {
      type: 'InfoForm',
      title: '请描述一下您对面料的需求',
      items: [
        {
          type: 'textarea',
          label: '需求描述',
          key: 'fabricDesc',
          tooltip:
            '请大致描述一下希望布料的外观或功能上的需求，如:弹性好，柔软等'
        },
        {
          type: 'image',
          label: '上传面料图片',
          key: 'fabricUrl'
        }
      ],
      next
    }
  },
  114: (): any => {
    return {
      type: 'BranchOption',
      title: '请问您是否可以提供样衣邮寄',
      key: 'clothingQuestionCanSendSample',
      options: [
        {
          label: '我有样衣',
          value: 'A',
          next: '3',
          bridge: '2'
        },
        {
          label: '我没有样衣',
          value: 'B',
          next: '5'
        }
      ]
    }
  }
}
